module.exports = __webpack_public_path__ + "static/media/Smile Face.f05a9898.png";